
import React, { useState } from "react";
import './App.css';

function App() {
    const [username, setUsername] = useState("");  // 사용자 이메일 입력값
    const [emails, setEmails] = useState([]);  // 이메일 목록
    const [selectedEmailBody, setSelectedEmailBody] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);  // 현재 페이지 상태
    const [emailsPerPage] = useState(10);  // 한 페이지에 표시할 이메일 개수
    const [sortOrder, setSortOrder] = useState("asc");  // 정렬 순서 상태
    const domain = "@meditqa.com";  // 자동으로 추가할 도메인

    // 이메일 목록 가져오기
    const getEmails = () => {
        setLoading(true);
        setSelectedEmailBody(null);  // 새로 이메일 목록을 가져올 때 본문을 초기화
        setError(null);
        setCurrentPage(1);

        // 이메일에 @meditqa.com이 없으면 추가
        let fullUsername = username;
        if (!username.includes(domain)) {
            fullUsername = username + domain;
        }

        fetch("/api/emails", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ username: fullUsername })  // 도메인 추가된 username 전달
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error("네트워크 응답이 올바르지 않습니다.");
                }
                return response.json();
            })
            .then(data => {
                setEmails(data.emails || []);
                setLoading(false);
                setError(null);
            })
            .catch(error => {
                console.error("이메일 목록 가져오기 오류:", error);
                setError("이메일 목록을 가져오는 데 실패했습니다.");
                setLoading(false);
            });
    };
    // 이메일 정렬 함수
    const sortedEmails = emails.slice().sort((a, b) => {
        if (sortOrder === "asc") {
            return a.id - b.id; // 오름차순 정렬
        } else {
            return b.id - a.id; // 내림차순 정렬
        }
    });


    // 페이지네이션을 위한 이메일 슬라이싱
    const indexOfLastEmail = currentPage * emailsPerPage;
    const indexOfFirstEmail = indexOfLastEmail - emailsPerPage;
    const currentEmails = sortedEmails.slice(indexOfFirstEmail, indexOfLastEmail);

    // 특정 이메일 본문 가져오기
    const getEmailBody = (emailId) => {
        // 이메일에 @meditqa.com이 없으면 추가
        let fullUsername = username;
        if (!username.includes(domain)) {
            fullUsername = username + domain;
        }
        setLoading(true);
        setError(null);
        fetch(`/api/email/${emailId}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ username: fullUsername })  // 비밀번호를 포함하지 않음
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error("네트워크 응답이 올바르지 않습니다.");
                }
                return response.json();
            })
            .then(data => {
                setSelectedEmailBody(data.body);
                setLoading(false);
                setError(null);
            })
            .catch(error => {
                console.error("이메일 본문 가져오기 오류:", error);
                setError("이메일 본문을 가져오는 데 실패했습니다.");
                setLoading(false);
            });
    };

    // 정렬 순서를 토글하는 함수
    const toggleSortOrder = () => {
        setSortOrder((prevOrder) => (prevOrder === "asc" ? "desc" : "asc"));
    };

    // 페이지 변경 함수
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const totalPages = Math.ceil(emails.length / emailsPerPage);

    const [selectedEmails, setSelectedEmails] = useState([]);  // 선택된 메일 ID들

    // 이메일 체크박스 선택 처리
    const toggleEmailSelection = (emailId) => {
        setSelectedEmails((prevSelected) =>
            prevSelected.includes(emailId)
                ? prevSelected.filter(id => id !== emailId)
                : [...prevSelected, emailId]
        );
    };

    // 이메일 삭제 API 요청
    const deleteSelectedEmails = () => {
        if (selectedEmails.length === 0) return;

        let fullUsername = username.includes(domain) ? username : username + domain;

        fetch("/api/email/delete", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ username: fullUsername, emailIds: selectedEmails })
        })
            .then(res => res.json())
            .then(data => {
                alert("삭제 성공!");
                setSelectedEmails([]);
                getEmails();  // 삭제 후 목록 새로고침
            })
            .catch(err => {
                console.error("삭제 실패:", err);
                alert("삭제 실패");
            });
    };

    return (
        <div className="App">
            <h1>Medit QA Mail Server</h1>
            <div>
                <input
                    id="email-input"
                    type="text"
                    placeholder="이메일"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}  // 이메일 입력
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            getEmails();
                        }
                    }}
                />
                <button id="email-load" onClick={getEmails}>이메일 가져오기</button>
                <button id="sort" onClick={toggleSortOrder}>
                    정렬: {sortOrder === "asc" ? "오름차순" : "내림차순"}
                </button>
                <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage <= 1}
                >
                    이전
                </button>
                <span> 페이지 {currentPage} / {totalPages} </span>
                <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                >
                    다음
                </button>
                {/* ✅ 선택된 메일 삭제 영역 */}
                <span style={{ marginLeft: "20px" }}>
                    선택됨: {selectedEmails.length}개
                </span>
                <button onClick={deleteSelectedEmails} disabled={selectedEmails.length === 0}>
                    선택 삭제
                </button>
            </div>

            {loading ? (
                <p>로딩 중...</p>
            ) : error ? (
                <p style={{ color: "red" }}>{error}</p>
            ) : (
                <div style={{display: "flex"}}>
                    <ul style={{width: "30%", borderRight: "1px solid #ccc", padding: 0, margin: 0}}>
                        {Array.isArray(currentEmails) && currentEmails.length === 0 ? (
                            <li style={{ padding: "10px", color: "gray", fontStyle: "italic" }}>
                                메일이 존재하지 않습니다.
                            </li>
                        ) : (
                        currentEmails.map((email) => (
                            <li
                                id={email.subject}
				key={email.id}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "10px",
                                    borderBottom: "1px solid #eee",
                                    backgroundColor: selectedEmailBody?.id === email.id ? "#f5faff" : "white",
                                    cursor: "pointer"
                                }}
                            >
                                {/* 체크박스 영역 최소화 */}
                                <div style={{flexShrink: 0, marginRight: "10px", paddingTop: "5px"}}>
                                    <input
                                        type="checkbox"
                                        checked={selectedEmails.includes(email.id)}
                                        onChange={() => toggleEmailSelection(email.id)}
                                    />
                                </div>

                                {/* 이메일 정보 */}
                                <div
                                    onClick={() => getEmailBody(email.id)}
                                    style={{
                                        flexGrow: 1,
                                        border: selectedEmailBody?.id === email.id ? "2px solid #007bff" : "none",
                                        padding: "6px",
                                        borderRadius: "5px",
                                        boxShadow: selectedEmailBody?.id === email.id ? "0 4px 8px rgba(0, 123, 255, 0.2)" : "none",
                                        transition: "all 0.3s ease"
                                    }}
                                >
                                    <h3 style={{margin: "0 0 5px 0"}}>{email.subject}</h3>
                                    <p style={{margin: "0 0 3px 0", fontSize: "14px"}}>
                                        <strong>보낸 사람:</strong> {email.from}
                                    </p>
                                    <p style={{margin: 0, fontSize: "12px", color: "#666"}}>
                                        <strong>수신 시간:</strong> {new Date(email.receivedAt).toLocaleString("ko-KR")}
                                    </p>
                                </div>
                            </li>
                        )))}
                    </ul>
                    {selectedEmailBody && (
                        <div style={{marginLeft: "20px", width: "70%"}}>
                            <h1>제목 : {selectedEmailBody.subject}</h1>
                            {/* 발신자 */}
                            <p><strong>보낸 사람:</strong> {selectedEmailBody.from}</p>
                            {/* 수신 시간 */}
                            <p><strong>수신 시간:</strong> {new Date(selectedEmailBody.receivedAt).toLocaleString()}</p>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: selectedEmailBody.body,
                                }}
                            />
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default App;
